<template>
  <div style="height: 100%">
    <div style="margin-bottom: 10px;" v-if="channelArray.length > 1">
      <span style="float:left;">通道：</span>
      <el-select
        @change="changeChannel"
        placeholder="请选择通道"
        size="mini"
        style="width: 50%;"
        v-model="channel">
        <el-option
          :key="item"
          :value="item"
          v-for="item in channelArray">
          {{ item }}
        </el-option>
      </el-select>
    </div>
    <video autoplay controls height="100%" muted ref="videoElement" width="100%"></video>
  </div>
</template>

<script>
import flvJs from "flv.js";
import {cameraHeartbeat, getConnectCamera} from "@/network/video";
import {getDVRInfo} from "@/network/DVR";

export default {
  name: "DVRVideoComponent",
  props: {
    properties: {
      type: Object,
      default: () => {
      },
    },
    deviceInfo: {
      type: Object,
      default: () => {
      },
    }
  },
  data() {
    return {
      timer: '',
      flvPlayer: null,
      cameraId: null,
      channelArray: [],
      channel: 0,
    };
  },
  watch: {
    properties() {
      this.getDVRInfo()
    }
  },
  destroyed() {
    this.destroy()
  },
  mounted() {
    this.getDVRInfo()
  },
  methods: {
    //获取视频通道信息
    getDVRInfo() {
      if (this.properties) {
        getDVRInfo("hikvision", this.properties.User, this.properties.pwd, this.properties.IP).then(res => {
          if (res.code === 0) {
            const chanNum = res.data.chanNum
            const startChan = res.data.startChan
            const dvrDeviceChanInfos = res.data.dvrDeviceChanInfos
            this.channelArray = []
            if (chanNum && chanNum > 0) {
              for (let i = startChan; i < startChan + chanNum; i++) {
                this.channelArray.push(i)
              }
            }
            if (dvrDeviceChanInfos && dvrDeviceChanInfos.length > 0) {
              dvrDeviceChanInfos.forEach(item => {
                if (item.byChannel !== 0) {
                  this.channelArray.push(item.byIPID)
                }
              })
            }
            if (this.channelArray.length > 0) {
              this.channel = this.channelArray[0]
              this.getCameraId()
            }
          }
        })
      }
    },
    getCameraId() {
      if (this.properties) {
        let cameraRtspEnum = "HAI_KANG_VCR"
        if (this.deviceInfo.brandCnName === '大华') {
          cameraRtspEnum = "DA_HUA"
        }
        getConnectCamera(cameraRtspEnum, this.properties.User, this.properties.pwd, this.properties.IP, this.channel).then(res => {
          if (res.code === 0) {
            this.cameraId = res.data.cameraId
            this.initFlv()
          }
        })
      }
    },
    initFlv() {
      if (flvJs.isSupported()) {
        var videoElement = this.$refs.videoElement;
        this.flvPlayer = flvJs.createPlayer({
          type: 'flv',
          isLive: true,
          hasAudio: false,
          url: window.g.httpFlvUrl + this.cameraId
        });
        this.flvPlayer.attachMediaElement(videoElement);
        this.flvPlayer.load();
        this.flvPlayer.play();
        //异常监听
        this.flvPlayer.on(flvJs.Events.ERROR, (errType, errDetail) => {
          this.errorCallback(errType, errDetail)
        });
        //视频播放完毕
        this.flvPlayer.on(flvJs.Events.LOADING_COMPLETE, () => {
        });
        let cameraHeartBeat = {};
        cameraHeartBeat['cameraHeartbeat' + this.cameraId + ':5000'] = this.cameraHeartbeat
        this.$store.dispatch('addIntervalObj', cameraHeartBeat)
      }
    },
    cameraHeartbeat() {
      cameraHeartbeat(this.cameraId).then(res => {
        console.log(res.data);
      })
    },
    errorCallback(errType, errDetail) {
      if (this && !this.isDestroyed) {
        return
      }
      console.log("---ERROR--", errType, errDetail)
      // errType是 NetworkError时，对应errDetail有：Exception、HttpStatusCodeInvalid、ConnectingTimeout、EarlyEof、UnrecoverableEarlyEof
      // errType是 MediaError时，对应errDetail是MediaMSEError
      if (this.timer) {
        clearTimeout(this.timer);
      }
      //网络异常情况
      if (errType === flvJs.ErrorTypes.NETWORK_ERROR && errDetail === flvJs.ErrorDetails.NETWORK_UNRECOVERABLE_EARLY_EOF) {
        this.getCameraId();
      } else {
        this.timer = setTimeout(this.getCameraId, 5000);
      }
    },
    changeChannel() {
      this.destroy()
      this.getCameraId();
    },
    destroy() {
      this.$store.dispatch('removeIntervalObj', 'cameraHeartbeat' + this.cameraId)
      this.flvPlayer.pause()
      this.flvPlayer.unload()
      this.flvPlayer.detachMediaElement()
      this.flvPlayer.destroy()
      this.flvPlayer = null
      console.log("---destroy---");
    }
  }
}
</script>

<style scoped>

</style>
